<template>
    <div>
        <ContentHeader path-set-type="append" :gameplan-nav="false" />
        <div class="content-wrapper" v-loading="loading">
            <el-row>
                <div class="title"  @click="collClick('orderShow1')" style="margin-top: 20px;cursor: pointer;">
                    <i :class="[orderShow1 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
                    基本信息
                </div>
                <div class="card-box is-hover-shadow" v-show="orderShow1">
                    <div class="form">
                        <div class="item">
                            <div class="item-left">变更类型</div>
                            <div class="item-right">
                                <span v-if="themeDetail.changeType == '1'">活动执行日期</span>
                                <span v-if="themeDetail.changeType == '2'">售点</span>
                                <span v-if="themeDetail.changeType == '3'">售点和活动执行日期</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="item-left">变更时间</div>
                            <div class="item-right">{{getTime(themeDetail.createTime,true)}}</div>
                        </div>
                        <div class="item">
                            <div class="item-left">变更人</div>
                            <div class="item-right">
                                <span v-if="themeDetail.updateType == '0'">供应商</span>
                                <span v-if="themeDetail.updateType == '1'">TM</span>
                            </div>
                        </div>
                        <div class="item">
                            <div class="item-left">变更状态</div>
                            <div class="item-right">
                                变更成功
                            </div>
                        </div>
                        <div class="item">
                            <div class="item-left">变更理由</div>
                            <div class="item-right">
                                <span v-if="themeDetail.changeReason">{{ themeDetail.changeReason}}</span>
                                <span v-else>暂无理由</span>
                            </div>
                        </div>
                    </div>
                    <div class="form">
                        <div class=" item-image " style="width:100%">
                            <div class="item-left">变更凭证</div>
                            <div class="image-right" v-if="activityImageList.length > 0" >
                                <div class="item-img" v-for="i,index in activityImageList" :key="i.activityImageId">
                                    <div class="img-item">
                                        <el-image  :initial-index="index" :src="getImgList(activityImageList)[index]" :preview-src-list="getImgList(activityImageList)" class="img" />
                                    </div>
                                </div>
                            </div>
                            <div class="image-right" v-else >
                                暂无凭证
                            </div>
                        </div>
                    </div>
                </div>
                <div class="title" @click="collClick('orderShow2')" style="margin-top: 20px;cursor: pointer;">
                    <i :class="[orderShow2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
                    变更前信息
                </div>
                <div class="card-box is-hover-shadow"  v-show="orderShow2">
                    <div class="form">
                        <div class="item" v-if="pocRelateType !== '1' && (themeDetail.changeType == '2' || themeDetail.changeType == '3')">
                            <div class="item-left" v-if="pocRelateType == '0'">活动地点</div>
                            <div class="item-left" v-if="pocRelateType == '2'">街区名称</div>
                            <div class="item-right"  v-if="themeDetail.oldBlockVO">
                                <span v-if="themeDetail.oldBlockVO.blockName">{{themeDetail.oldBlockVO.blockName}}</span>
                                <span v-else>暂无数据</span>
                            </div>
                            <div class="item-right" v-else>
                                <span>暂无数据</span>
                            </div>
                        </div>
                        <div class="item" v-if="themeDetail.changeType == '2' || themeDetail.changeType == '3'">
                            <div class="item-left">百威联系人</div>
                            <div class="item-right">
                                <span v-if="themeDetail.bwContactOld">{{themeDetail.bwContactOld}}</span>
                                <span v-else>暂无数据</span>
                            </div>
                        </div>
                        <div class="item"  v-if="pocRelateType == '0' && (themeDetail.changeType == '2' || themeDetail.changeType == '3')">
                            <div class="item-left" >城市</div>
                            <div class="item-right" v-if="themeDetail.blockInfoOld">
                                <span v-if="themeDetail.blockInfoOld">{{blockInfoOld.areaName}}</span>
                                <span v-else>暂无数据</span>
                            </div>
                            <div class="item-right" v-else>
                                <span>暂无数据</span>
                            </div>
                        </div>
                        <div class="item" v-if="pocRelateType == '0' && (themeDetail.changeType == '2' || themeDetail.changeType == '3')">
                            <div class="item-left" >活动详细地址</div>
                            <div class="item-right" v-if="themeDetail.oldBlockVO">
                                <span v-if="themeDetail.oldBlockVO.blockAddress">{{themeDetail.oldBlockVO.blockAddress}}</span>
                                <span v-else>暂无数据</span>
                            </div>
                            <div class="item-right" v-else>
                                <span>暂无数据</span>
                            </div>
                        </div>
                        <div class="item" style="width: 100%;" v-if="themeDetail.changeType == '1' || themeDetail.changeType == '3'" >
                            <div class="item-left">活动执行日期</div>
                            <div class="item-right" v-if="themeDetail.timeOldList">
                                <span>{{ getTimename(themeDetail.timeOldList) }}</span>
                                <span style="color:#409EFF;margin-left: 10px;">{{ themeDetail.timeOldList.length }}天</span>
                            </div>
                            <div class="item-right" v-else>暂无数据</div>
                        </div>
                        <!-- v-if="pocRelateType !== '0' && (themeDetail.changeType == '2' || themeDetail.changeType == '3') -->
                        <div class="item" v-if="pocRelateType !== '0' && (themeDetail.changeType == '2' || themeDetail.changeType == '3')"  style="width: 100%;margin-top: 10px;"  >
                            <div class="item-left">售点信息</div>
                            <div class="item-right">
                                <div class="search-table">
                                    <el-table
                                        :data="oldTablelist"
                                        style="width: 100%"
                                        tooltip-effect="dark"
                                        empty-text="暂无数据"
                                        border
                                        show-header
                                        >
                                        <el-table-column
                                        
                                        label="售点名称"
                                        align="center"
                                        >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.pocName">{{ scope.row.pocName }}</span>
                                            <span v-else>暂无数据</span>
                                        </template>
                                        </el-table-column>

                                        <el-table-column
                                        prop="pocAddress"
                                        label="地址"
                                        align="center"
                                        show-overflow-tooltip
                                        >
                                        </el-table-column>
 
                                        <el-table-column
                                        align="center"
                                        show-overflow-tooltip
                                        label="售点联系人信息"
                                        >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.contactPerson">{{ scope.row.contactPerson }}</span>
                                            <span v-if="scope.row.contactPhone">-{{ scope.row.contactPhone }}</span>
                                        </template>
                                        </el-table-column>

                                        <el-table-column
                                        label="状态"
                                        align="center"
                                        show-overflow-tooltip
                                        >
                                        <template slot-scope="scope">
                                            <span :class="getStatusStyle(getStatus('old',scope.row))">{{getStatus('old',scope.row)}}</span>
                                        </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="title" @click="collClick('orderShow3')" style="margin-top: 20px;cursor: pointer;">
                    <i :class="[orderShow3 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
                    变更后信息
                </div>
                <div class="card-box is-hover-shadow"  v-show="orderShow3">
                    <div class="form">
                        <div class="item"  v-if="pocRelateType !== '1' && (themeDetail.changeType == '2' || themeDetail.changeType == '3')">
                            <div class="item-left" v-if="pocRelateType == '0'">活动地点</div>
                            <div class="item-left" v-if="pocRelateType == '2'">街区名称</div>
                            <div class="item-right"  v-if="themeDetail.newBlockVO">
                                <span v-if="themeDetail.newBlockVO.blockName">{{themeDetail.newBlockVO.blockName}}</span>
                                <span v-else>暂无数据</span>
                            </div>
                            <div class="item-right" v-else>
                                <span>暂无数据</span>
                            </div>
                        </div>
                        <div class="item"  v-if="themeDetail.changeType == '2' || themeDetail.changeType == '3'">
                            <div class="item-left">百威联系人</div>
                            <div class="item-right">
                                <span v-if="themeDetail.bwContactNew">{{themeDetail.bwContactNew}}</span>
                                <span v-else>暂无数据</span>
                            </div>
                        </div>
                        <div class="item"  v-if="pocRelateType == '0' && (themeDetail.changeType == '2' || themeDetail.changeType == '3')">
                            <div class="item-left" >城市</div>
                            <div class="item-right" v-if="themeDetail.blockInfoNew">
                                <span v-if="themeDetail.blockInfoNew">{{blockInfoNew.areaName}}</span>
                                <span v-else>暂无数据</span>
                            </div>
                            <div class="item-right" v-else>
                                <span>暂无数据</span>
                            </div>
                        </div>
                        <div class="item"  v-if="pocRelateType == '0' && (themeDetail.changeType == '2' || themeDetail.changeType == '3')">
                            <div class="item-left" >活动详细地址</div>
                            <div class="item-right" v-if="themeDetail.newBlockVO">
                                <span v-if="themeDetail.newBlockVO.blockAddress">{{themeDetail.newBlockVO.blockAddress}}</span>
                                <span v-else>暂无数据</span>
                            </div>
                            <div class="item-right" v-else>
                                <span>暂无数据</span>
                            </div>
                        </div>
                        <div class="item" style="width: 100%;"  v-if="themeDetail.changeType == '1' || themeDetail.changeType == '3'" >
                            <div class="item-left">活动执行日期</div>
                            <div class="item-right" v-if="themeDetail.timeNewList">
                                <span>{{ getTimename(themeDetail.timeNewList) }}</span>
                                <span style="color:#409EFF;margin-left: 10px;">{{ themeDetail.timeNewList.length }}天</span>
                            </div>
                            <div class="item-right" v-else>暂无数据</div>
                        </div>
                        <!-- v-if="pocRelateType !== '0'" && (themeDetail.changeType == '2' || themeDetail.changeType == '3') -->
                        <div class="item" v-if="pocRelateType !== '0' && (themeDetail.changeType == '2' || themeDetail.changeType == '3')"  style="width: 100%;margin-top: 10px;"  >
                            <div class="item-left">售点信息</div>
                            <div class="item-right">
                                <div class="search-table">
                                    <el-table
                                        :data="newTablelist"
                                        style="width: 100%"
                                        tooltip-effect="dark"
                                        empty-text="暂无数据"
                                        border
                                        show-header
                                        >
                                        <el-table-column
                                        
                                        label="售点名称"
                                        align="center"
                                        >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.pocName">{{ scope.row.pocName }}</span>
                                            <span v-else>暂无数据</span>
                                        </template>
                                        </el-table-column>

                                        <el-table-column
                                        prop="pocAddress"
                                        label="地址"
                                        align="center"
                                        show-overflow-tooltip
                                        >
                                        </el-table-column>
 
                                        <el-table-column
                                        align="center"
                                        show-overflow-tooltip
                                        label="售点联系人信息"
                                        >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.contactPerson">{{ scope.row.contactPerson }}</span>
                                            <span v-if="scope.row.contactPhone">-{{ scope.row.contactPhone }}</span>
                                        </template>
                                        </el-table-column>

                                        <el-table-column
                                        label="状态"
                                        align="center"
                                        show-overflow-tooltip
                                        >
                                        <template slot-scope="scope">
                                            <span :class="getStatusStyle(getStatus('new',scope.row))">{{getStatus('new',scope.row)}}</span>
                                        </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { commonUtils } from '@/utils/common'
    import gameplanApi from '../../api/gameplan'
    import ContentHeader from '@/components/content-header'
    import ReportPop from './components/activity-report-pop.vue'
    import configBuChangePop from './components/config-buChange-pop.vue'
    export default {
      name: 'activity-history-detail',
      components: {
        ContentHeader,
        ReportPop,
        configBuChangePop
      },
      data () {
        return {
            activityId: "",
            orderShow1: true,
            orderShow2: true,
            orderShow3: true,
            loading: false,
            pocRelateType:'',
            pocCountMin:'',
            themeDetail:{},
            themeDetailId:'',
            oldTablelist: [],
            newTablelist: [],
            changeApprovalId:'',
            activityImageList:[], // 变更凭证
            blockInfoNew: {},
            blockInfoOld: {}
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        this.pocRelateType = this.$route.query.pocRelateType
        this.activityId = this.$route.query.activityId
        this.themeDetailId  = this.$route.query.themeDetailId
        this.changeApprovalId = this.$route.query.changeApprovalId
        let themeDetail =  this.$route.query.detailItem
        this.themeDetail = JSON.parse(themeDetail)
        this.oldTablelist = this.themeDetail.oldPocList || []
        this.newTablelist = this.themeDetail.newPocList || []
        this.blockInfoNew  = JSON.parse(this.themeDetail.blockInfoNew)
        this.blockInfoOld  = JSON.parse(this.themeDetail.blockInfoOld)
        
        // console.log(this.oldTablelist,'this.oldTablelist');
        // console.log(this.themeDetail,'this.themeDetail');
        
        this.init()
      },
      mounted () {},
      updated () {
      },
      methods: {
        init () {
            this.viewHistorydetail()
        },
        getStatusStyle(val) {
            if (val === 'new') return 'color-green'
            else if (val === 'delete') return 'color-red'
            else return 'gp-activity-date'
        },
        getStatus(type, row) {
            if (type === 'old') {
                let isDelete = true
                this.newTablelist.forEach(item => {
                if (item.pocIgniteId === row.pocIgniteId) isDelete = false
                })
                return isDelete ? 'delete' : '---'
            } else if (type === 'new') {
                let isAdd = true
                this.oldTablelist.forEach(item => {
                if (item.pocIgniteId === row.pocIgniteId) isAdd = false
                })
                return isAdd ? 'new' : '---'
            }
        },
        getTimename (timeListno) {
            if (timeListno) {
                let name = ''
                name = timeListno.map((item)=>{
                    return item
                }).join(' | ')
                return name
            } else {
                return 'null'
            }
        },
        getImgList(dataList) {
            const imgList = []
            if (!dataList) {
                return []
            }
            dataList.forEach(item => {
                imgList.push(this.getImg(item.imageUri))
            })
            return imgList
        },
        getSplit (val) {
            return val.split('|')[0]
        },
        getImg (uri) {
            return commonUtils.getImageUrl(uri)
        },
        getTime (timestamp,sign) {
        if (timestamp === 0 || timestamp == null) {
            return '暂无数据'
        } else {
            var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
            const Y = date.getFullYear() + '-'
            const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
            const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
            const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
            if (!sign) {
                return Y + M + D

            } else {
                return Y + M + D + '' + h + m + s 
            }
        }
        },
        // 获取历史变更详情
        async viewHistorydetail () {
            let params = {
                changeApprovalId: this.changeApprovalId,
                activityId:this.activityId  
            }
            let {data} = await gameplanApi.viewHistorydetail(params)
            if (data.resultCode == '0') {
                this.activityImageList = data.resultData.gpActivityImageList
            }
        },
        // 订单明细显示隐藏
        collClick (name) {
            if (name == 'orderShow1') {
                this.orderShow1 = !this.orderShow1
            } else if (name == 'orderShow2') {
                this.orderShow2 = !this.orderShow2
            } else if (name == 'orderShow3') {
                this.orderShow3 = !this.orderShow3
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .color-red{
        color:red;
        cursor: pointer;
    }
    .color-green{
        color:green;
        cursor: pointer;
    }
    .gp-activity-date{
        color:rgb(0, 168, 235);
        cursor: pointer;
    }
    .content-wrapper {
        min-height: calc(100vh - 320px) !important;
        font-family: SourceHanSansSC-regular;
        padding-top: 10px;
        .title {
            line-height: 40px;
            text-align: left;
            color: #101010;
            font-size: 18px;
            font-weight: 600;
        }
        .card-box {
            padding: 10px 20px;
            background-color: #FFFFFF;
            color: #101010;
            border-radius: 10px;
            .form{
                display: flex;
                flex-wrap: wrap;
                padding-left: 8px;
                .item {
                    width: 50%;
                    line-height: 33px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    text-align: left;
                    .item-left {
                        text-align: right;
                        width: 127px;
                        font-weight: 600;
                        margin-right: 40px;
                    }
                    .item-right {
                        flex: 1;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                            .search-table {
                            ::v-deep .el-table th.el-table__cell {
                                color: #101010;
                                background-color: rgba(232, 232, 232);
                                padding: 5px 0;
                            }
                            ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                                background-color: #FFFFFF !important;
                            }
                            ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                                background-color: #FFFFFF !important;
                            }
                        }
                    }
                }
                .item-sign {
                    line-height: 33px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    text-align: left;
                    padding-left: 55px;
                    .sign {
                        display: flex;
                        margin: 0px 15px;
                        .sign-left {
                            margin-right: 5px;
                            font-weight: normal;
                            line-height: 33px;
                        }
                        .sign-right {
                            margin-top: 3px;
                            .color-green {
                                color: rgb(42, 219, 33);
                                font-size: 18px;
                            }
                            .color-red {
                                color: rgb(219, 93, 33);
                                font-size: 18px;
                            }
                        }
                    } 
                }
                .item-image {
                    width: 50%;
                    line-height: 33px;
                    font-size: 14px;
                    color: #101010;
                    display: flex;
                    text-align: left;
                    .item-left {
                        text-align: right;
                        width: 127px;
                        font-weight: 600;
                        margin-right: 40px;
                    }
                    .image-right {
                        flex: 1;
                        display: flex;
                        flex-wrap: wrap;
                        .item-img {
                            .img-item {
                                margin-right: 15px;
                                margin-bottom: 5px;
                                width: 64px;
                                cursor: pointer;
                                overflow:hidden;
                                max-height: 64px;
                                .img {
                                    width:100%;
                                    height:100%;
                                    background-position:center center;
                                    background-repeat: no-repeat;
                                    -webkit-background-size:cover;
                                    -moz-background-size:cover;
                                    background-size:cover;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
